export default defineNuxtPlugin(() => {
  try {
    const version = useRuntimeConfig().public.VERSION;
    window.fe_version = JSON.parse(version);
  } catch (error) {
    window.fe_version = { msg: "Unknown", hash: "Unknown", date: "Unknown"};
  }
})
